export default "__VITE_ASSET__Bbbz$5RX__"